(function(win, lib) {
    var doc = win.document; //��ǰ�ĵ�����
    var docEl = doc.documentElement; //�ĵ������Ԫ�ص�ֻ������
    var metaEl = doc.querySelector('meta[name="viewport"]');
    var flexibleEl = doc.querySelector('meta[name="flexible"]');
    var dpr = 0;
    var scale = 0;
    var tid;
    var flexible = lib.flexible || (lib.flexible = {});

    if (metaEl) {
        //��meta��viewport�ı�ǩ������scaleʱ��������scale�ֶ�����dpr
        console.warn('���������е�meta��ǩ���������ű���');
        var match = metaEl.getAttribute('content').match(/initial\-scale=([\d\.]+)/);
        if (match) {
            scale = parseFloat(match[1]);
            dpr = parseInt(1 / scale);
        }
    } else if (flexibleEl) {
        //��meta��flexible�ı�ǩ����ʱ���ݴ�����dpr
        var content = flexibleEl.getAttribute('content');
        if (content) {
            var initialDpr = content.match(/initial\-dpr=([\d\.]+)/);
            var maximumDpr = content.match(/maximum\-dpr=([\d\.]+)/);
            if (initialDpr) {
                dpr = parseFloat(initialDpr[1]);
                scale = parseFloat((1 / dpr).toFixed(2));
            }
            if (maximumDpr) {
                dpr = parseFloat(maximumDpr[1]);
                scale = parseFloat((1 / dpr).toFixed(2));
            }
        }
    }

    if (!dpr && !scale) {
        //����js��ȡ����devicePixelRatio����dpr��scale��scale��dpr�ĵ���
        var isAndroid = win.navigator.appVersion.match(/android/gi);
        var isIPhone = win.navigator.appVersion.match(/iphone/gi);
        var devicePixelRatio = win.devicePixelRatio;
        if (isIPhone) {
            // iOS�£�����2��3�������ֱ���2��3������
            if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
                dpr = 3;
            } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)){
                dpr = 2;
            } else {
                dpr = 1;
            }
        } else {
            // �����豸�£��Ծ�ʹ��1���ķ���
            dpr = 1;
        }
        scale = 1 / dpr;
    }

    docEl.setAttribute('data-dpr', dpr);
    //�ı��ֺŲ�����ʹ��rem��flexible���䷽���У��ı�ʹ��px��Ϊ��λ��ʹ��[data-dpr]���������ֲ�ͬdpr�µ��ı��ֺ�

    if (!metaEl) {
        //����meta��ǩ������nameΪviewport��content����scale�������ű�(Ĭ�ϡ������С���ű�)
        metaEl = doc.createElement('meta');
        metaEl.setAttribute('name', 'viewport');
        metaEl.setAttribute('content', 'initial-scale=' + scale + ', maximum-scale=' + scale + ', minimum-scale=' + scale + ', user-scalable=no');
        if (docEl.firstElementChild) {
            docEl.firstElementChild.appendChild(metaEl);
        } else {
            var wrap = doc.createElement('div');
            wrap.appendChild(metaEl);
            doc.write(wrap.innerHTML);
        }
    }

    window.refreshRem = function(){
        //����remֵ
        var width = docEl.getBoundingClientRect().width;
        if (width / dpr > 540) {
            width = 540 * dpr;
        }
        var rem = width / 10; //1rem = viewWidth / 10
        docEl.style.fontSize = rem + 'px';
        flexible.rem = win.rem = rem;
    }

    //resize��pageshow��ʱ300ms����refreshRem(),ʹ�÷�����������ֹ�¼�����Ƶ��������������������
    win.addEventListener('resize', function() {
        clearTimeout(tid);
        tid = setTimeout(refreshRem, 300);
    }, false);
    win.addEventListener('pageshow', function(e) {
        //��һ���Ự��ʷ��¼��ִ�е�ʱ�򴥷��¼�����������/ǰ����ť��ͬʱ����onloadҳ�津�����ʼ��ҳ��ʱ����
        if (e.persisted) {//��ʾ��ҳ�Ƿ����Ի���
            clearTimeout(tid);
            tid = setTimeout(refreshRem, 300);
        }
    }, false);

    //��html�ĵ����غͽ�����ɺ�����bodyԪ�������С
    if (doc.readyState === 'complete') {
        doc.body.style.fontSize = 14 * dpr + 'px';
    } else {
        doc.addEventListener('DOMContentLoaded', function(e) {
            doc.body.style.fontSize = 14 * dpr + 'px';
        }, false);
    }
    //���������С�������ƣ�css��pc��font-size��12px(�ƶ�����С��8px), Ҳ����css������12����DPRΪ1�����ƶ���dpr�п���Ϊ2��3��Ϊ�˱�֤���岻��С����Ҫ��12*dpr���л��㡣

    refreshRem();

    //ʵ��rem��px�໥ת��
    flexible.dpr = win.dpr = dpr;
    flexible.refreshRem = refreshRem;
    flexible.rem2px = function(d) {
        var val = parseFloat(d) * this.rem;
        if (typeof d === 'string' && d.match(/rem$/)) {
            val += 'px';
        }
        return val;
    }
    flexible.px2rem = function(d) {
        var val = parseFloat(d) / this.rem;
        if (typeof d === 'string' && d.match(/px$/)) {
            val += 'rem';
        }
        return val;
    }

})(window, window['lib'] || (window['lib'] = {}));


// WEBPACK FOOTER //
// ./src/assets/js/rem.js